<script>
    import url from "url2";

    import { buyGems } from "../stores/buyGems";

    import fetch from "../lib/fetch-polyfill";

    import css from "./embed.css";

    import Spinner     from "../spinner/spinner.svelte";
    import Maintenance from "../maintenance/maintenance.svelte";

    export let type; // gems/upgrade/code

    function embed() {
        const queryKey = {
            s    : window.native.stats.sessionId,
            lang : window.native.stats.language.slice(0, 2)
        };

        if (window.native.player.remoteClientIp) {
            queryKey.remoteClientIp = window.native.player.remoteClientIp;
        }

        return fetch(url.format({
            path : `/ws/embed/v2/${type}`,
            queryKey
        }));
    }

    function closeEmbed(e) {
        // don't close when clicking modal content, only when clicking on the skrim
        if (e.target !== e.currentTarget) {
            return;
        }
        buyGems.set(false);
    }
</script>

<div class={css.skrim} on:click={closeEmbed}>
    <div class={css.content}>
        <button class={css.close} on:click={closeEmbed}></button>

        {#await embed()}
            <div class={css.spinner}>
                <Spinner />
            </div>
        {:then iframeUrl}
            <iframe src={iframeUrl.url} frameborder="0" title={type} width={iframeUrl.width} height={iframeUrl.height}></iframe>
        {:catch error}
            <Maintenance error={error} />
        {/await}
    </div>
</div>